const RESOLUTION_MULTIPLIER = 1.5;

export const getMaskedPixels = async (
  imageUri: string,
  pathData: string,
  width: number,
  height: number,
  visibleRect?: { minX: number; maxX: number; minY: number; maxY: number }
): Promise<{ pixels: Uint8ClampedArray | number[], base64: string, blurredBase64?: string, pixelWidth: number, pixelHeight: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width * RESOLUTION_MULTIPLIER;
      canvas.height = height * RESOLUTION_MULTIPLIER;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error('Context failed'));

      ctx.scale(RESOLUTION_MULTIPLIER, RESOLUTION_MULTIPLIER);

      // Your app.js overlap/seam fix
      const p2d = new Path2D(pathData);
      ctx.fillStyle = 'black';
      ctx.fill(p2d);
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 1.5;
      ctx.lineJoin = 'round';
      ctx.stroke(p2d);

      ctx.globalCompositeOperation = 'source-in';

      ctx.globalCompositeOperation = 'source-in';

      // Proportional object-fit: cover mapping
      const imgScale = Math.max(width / img.width, height / img.height) * 1.05;
      const drawW = img.width * imgScale;
      const drawH = img.height * imgScale;
      const drawX = (width - drawW) / 2;
      const drawY = (height - drawH) / 2;

      ctx.save();
      // Webcam Mirroring
      ctx.translate(width / 2, height / 2);
      ctx.scale(-1, 1);
      ctx.translate(-width / 2, -height / 2);

      ctx.drawImage(img, drawX, drawY, drawW, drawH);
      ctx.restore();

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const base64 = canvas.toDataURL('image/png');

      // Blur pass
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = 'black';
      ctx.fill(p2d);
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 1.5;
      ctx.lineJoin = 'round';
      ctx.stroke(p2d);

      ctx.globalCompositeOperation = 'source-in';
      ctx.save();
      // Webcam Mirroring
      ctx.translate(width / 2, height / 2);
      ctx.scale(-1, 1);
      ctx.translate(-width / 2, -height / 2);

      ctx.filter = 'blur(10px)';
      ctx.drawImage(img, drawX, drawY, drawW, drawH);
      ctx.restore();

      const blurredBase64 = canvas.toDataURL('image/png');

      // Clear the canvas memory immediately to help the mobile garbage collector
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      resolve({
        pixels: imageData.data,
        base64: base64,
        blurredBase64: blurredBase64,
        pixelWidth: canvas.width,
        pixelHeight: canvas.height
      });
    };

    img.onerror = (e) => reject(e);
    img.src = imageUri;
  });
};